import React, { useState } from "react";
import person from "../../../assets/images/svg/person1.svg";
import doubblequotestop from "../../../assets/images/Icons/HomePage - Icons/testimonials-top.svg";
import doubblequotesbottom from "../../../assets/images/Icons/HomePage - Icons/testimonials-bottom.svg";
import image5 from "../../../assets/images/Icons/HomePage - Icons/image5.svg";
import rewards from "../../../assets/images/Icons/HomePage - Icons/fram61.svg";
import Certificate from "../../../assets/images/Icons/HomePage - Icons/Certificate.svg";
import { Modal } from "react-bootstrap";
type Props = {};

const TestimonialData = (props: Props) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img src={rewards} alt="rewards" />
        </Modal.Body>
      </Modal>

      {/* Mobile */}
      <div className="d-block d-md-none">
        <div
          className="p-20 bg-mobile-testimonials radius-20"
          style={{ height: "570px" }}
        >
          <h3 className=" header-color d-flex justify-content-center font-family-roboto align-items-center font-20 fonts-800 line-23 py-20 pb-35">
            Testimonials and Awards
          </h3>

          <div className="section4 container ">
            <div className="row ">
              <div className="col-md-6 col-sm-12 col-12 ps-4">
                <img
                  className="col-sm-2 wx-27 hx-21"
                  src={doubblequotestop}
                  alt={"doubble quotes"}
                />
                <p className="col-sm-8 text-black-10 font-12 font-family-roboto line-23 fonts-400 ml-5">
                  Launched in September 2022, Yantr.AI is a cognitive AI
                  solution that optimizes field services through deep analytical
                  insights, decision-making support, and future-proof strategic
                  planning. The platform combines technology, data, and people
                  to automate, optimize, and improve experiences for field
                  service operations. It helps clients identify lags and create
                  a flawless field ecosystem through actionable insights and
                  recommendations.
                </p>
                <div className="col-sm-2 d-flex justify-content-end">
                  <img
                    className="wx-27 hx-21 text-right"
                    src={doubblequotesbottom}
                    alt="doubble quotes bottom"
                  />
                </div>
                <div className="col-md-12 col-sm-6 col-12 mt-40 d-flex flex-row gap-10 pb-20">
                  <div className="col-md-3 col-sm-12 col-12 d-flex gap-2">
                    <div className="d-flex">
                      <img
                        className="wx-111 hx-101"
                        src={person}
                        alt={"person"}
                      />
                    </div>
                    <div className="m-1 pt-20">
                      <p className="text-primary1 font-12 fonts-800 font-family-roboto-flex line-14">
                        Sherrel Sonia Roche
                      </p>
                      <p className="text-grey font-10 line-12 fonts-400 font-family-roboto-flex">
                        Industry Principal, ICT Research Frost and Sullivan
                      </p>
                    </div>
                  </div>
                  <div className="border-gray-right d-flex justify-content-center flex-column align-items-center">
                    {/* <p className="text-primary1 font-18 fonts-800 font-family-roboto-flex line-24">
                  Sherrel Sonia Roche 123
                </p>
                <p className="text-grey font-16 fonts-400 font-family-roboto-flex">
                  Industry Principal, ICT Research Frost and Sullivan
                </p> */}
                  </div>
                  <div></div>
                </div>
              </div>
              <div className="col-md-2 d-none d-md-block col-sm-12 col-4 d-flex justify-content-start align-items-start pt-10">
                <img className="wx-171 hx-171" src={image5} alt={"person"} />
              </div>

              <div className={``}>
                <div className=" d-flex justify-content-center pb-30">
                  <button
                    // textclass="font-16 fonts-500 line-19 font-family-roboto-flex justify-content-center text-black"
                    className="wx-147 hx-30 text-center text-black line-11 font-family-roboto-flex justify-content-center font-12 fonts-400 bg-mobile-testimonials radius-10 award-button"
                    onClick={() => setShow(true)}
                  >
                    <img className="px-2" src={Certificate} alt="icon" />
                    View awards
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Website */}
      <div className="d-none d-md-block">
        <h3 className="header-color d-flex justify-content-center font-family-roboto align-items-center font-30 fonts-800 line-35 py-40">
          Testimonials and Awards
        </h3>

        <div
          className="section4 container height-medium"
          style={{ height: "400px" }}
        >
          <div className="row">
            <div className="col-md-3 col-sm-12 col-12 d-flex justify-content-end align-items-end">
              <img className="wx-171 hx-171" src={person} alt={"person"} />
            </div>
            <div className="col-md-6 col-sm-12 col-12 ps-4">
              <img
                className="wx-70 hx-55 pb-2"
                src={doubblequotestop}
                alt={"doubble quotes"}
              />
              <p className="text-black-10 font-18 font-family-roboto line-24 fonts-400 ml-5">
                Launched in September 2022, Yantr.AI is a cognitive AI solution
                that optimizes field services through deep analytical insights,
                decision-making support, and future-proof strategic planning.
                The platform combines technology, data, and people to automate,
                optimize, and improve experiences for field service operations.
                It helps clients identify lags and create a flawless field
                ecosystem through actionable insights and recommendations.
              </p>
              <div className="d-flex justify-content-end mt-3">
                <img
                  className="wx-37 hx-27 text-right"
                  src={doubblequotesbottom}
                  alt="doubble quotes bottom"
                />
              </div>
              <div className="col-md-12 col-sm-6 col-12 mt-40 d-flex flex-row gap-4">
                <div className="border-gray-right d-flex justify-content-start flex-column align-items-start wp-45">
                  <p className="text-primary1 font-18 fonts-800 font-family-roboto-flex line-24">
                    Sherrel Sonia Roche
                  </p>
                  <p className="text-grey font-16 fonts-400 font-family-roboto-flex">
                    Industry Principal, ICT Research Frost and Sullivan
                  </p>
                </div>
                <div></div>
              </div>
            </div>
            <div className="col-md-2 d-none d-md-block col-sm-12 col-4 d-flex justify-content-start align-items-start pt-50">
              <img className="wx-171 hx-171" src={image5} alt={"person"} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestimonialData;
